export type AmModeType = AmMode.design | AmMode.approval | AmMode.view | AmMode.final;

export enum AmMode {
  design = 'design',
  approval = 'approval',
  view = 'view',
  final = 'final-approval'
}
